//#region import libraries
import React, { useEffect } from 'react';

// custom components
import { CustomSpinner, Container, TextLabel } from '_atoms';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectEditBooking } from '_redux/slices/assistance-bookings/booking-requests-table'
import { selectProfileBubble, selectProfileBubbleStatus, getFirebaseInfo } from '_redux/slices/main-screen/user';

// bootstrap
import { Row, Col, Image } from 'react-bootstrap';

// placeholder
import placeholder from "_assets/images/profile/placeholder.jpeg";
//#endregion

const ProfilePicture = (props) => {
    return (
        <Image
            src={props.user && props.user.photoURL ? props.user.photoURL : placeholder}
            height={150}
            width={150}
            style={{ borderRadius: 100 }}
        />
    )
}

const FirebaseUserInfo = (props) => {

    //#region redux
    const dispatch = useDispatch();
    const selectedBooking = useSelector(selectEditBooking)
    const fetchStatus = useSelector(selectProfileBubbleStatus)
    const user = useSelector(selectProfileBubble);

    //#endregion

    // get firebase info on render
    useEffect(() => {
        if (props.user) {
            console.log('not getting user info...');
        }
        else if (selectedBooking && selectedBooking.userId && selectedBooking.userId !== "SITA") {
            // get profile information from firebase
            dispatch(getFirebaseInfo(selectedBooking.userId))
        }
    }, [selectedBooking]);

    return (
        <Container>
            {
                fetchStatus == 'loading' ?
                    <Row style={{ marginLeft: 100 }} className='mt-2'>
                        <CustomSpinner />
                    </Row>
                    :
                    fetchStatus == 'succeeded' ?
                        <Row>
                            <Col xs={2}>
                                <ProfilePicture user={user} />
                            </Col>
                            <Col>
                                <TextLabel
                                    disabled={true}
                                    label={'Display Name is'}>{user && user.displayName ? user.displayName : ''}
                                </TextLabel>
                                <TextLabel
                                    label={'Email'}
                                    disabled={true}
                                >{user && user.email ? user.email : ''}</TextLabel>
                            </Col>
                            <Col>
                                <TextLabel
                                    label={'Account Creation'}
                                    disabled={true}
                                >{user && user.metadata && user.metadata.creationTime ? user.metadata.creationTime : ''}</TextLabel>
                                <TextLabel
                                    label={'Last Sign In'}
                                    disabled={true}
                                >{user && user.metadata && user.metadata.lastSignInTime ? user.metadata.lastSignInTime : ''}</TextLabel>
                            </Col>
                        </Row>
                        :
                        <></>
            }
        </Container>
    );
};

export default FirebaseUserInfo;